const Notfoundpage = () => {
    return (
        <div className="notfoundpage" style={{
            width:"100%",
            height:"100vh",
            display:"flex",
            alignItems:"center",
            justifyContent:"center"
            }}>
            <h2>404 page Not Found</h2>
        </div>
      );
}
export default Notfoundpage;